import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgMail32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M9 4a2 2 0 0 0-2 2v3H5a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2h-2V6a2 2 0 0 0-2-2zm15 2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10.723L11.644 19h8.706L24 16.719zM7 10H5a1 1 0 0 0-1 1v3.223l3 1.875zm18 6.094V10h2a1 1 0 0 1 1 1v3.219zm2.965 10.17-6.674-6.673L28 15.398V26c0 .091-.012.18-.035.264m-.711.704L20.286 20h-8.579l-6.966 6.966A1 1 0 0 0 5 27h22a1 1 0 0 0 .254-.032M4 26V15.402l6.702 4.189-6.668 6.668A1.002 1.002 0 0 1 4 26" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgMail32);
export default Memo;